import { render, staticRenderFns } from "./Betriebsangaben.vue?vue&type=template&id=27ab525f"
import script from "./Betriebsangaben.vue?vue&type=script&lang=js"
export * from "./Betriebsangaben.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports